var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-backdrop"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fade),expression:"fade"}],staticClass:"mention-modal"},[_c('div',{staticClass:"modal-body"},[_vm._v(" You have been mentioned in a message ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }